import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';

const savedLang = localStorage.getItem('nexo_lang') || localStorage.getItem('kuphia_lang') || localStorage.getItem('i18nextLng') || 'es';
const initialLang = savedLang.startsWith('en') ? 'en' : 'es';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en }
    },
    lng: initialLang,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'nexo_lang',
      caches: ['localStorage']
    }
  });

export default i18n;
